module.exports = __webpack_public_path__ + "img/travel-ofs.c47afb0a.jpg";